import React, { useState } from 'react';
import './Card3D.css';

const Card3D = ({ title, children }) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    const cardClass = expanded ? "card3d expanded" : "card3d";

    return (
        <div className={cardClass}>
            <h2 onClick={toggleExpanded}>{title}</h2>
            {expanded && (
                <div className="card-content">
                    {children}
                </div>
            )}
        </div>
    );
};

export default Card3D;
